import React, {useEffect, useState, Fragment} from 'react';
import { NavLink, Link, useHistory, useLocation } from 'react-router-dom';
import Image from '../../../components/ui/Image';
import flatstore from 'flatstore';
import {getMenu} from '../../../utils/services';
import {currentLang, isProduct, productURL} from '../../../utils/functions';
// import LogoNL from '../../../assets/img/logo/logo_nl.svg';
// import LogoDE from '../../../assets/img/logo/logo_de.svg';
// import Logo from '../../../assets/img/logo/logo.svg';
import Basket from '../../../components/ui/Basket';
import { useTranslation } from 'react-i18next';
import W from '../../../components/ui/Word';
import {isNil} from 'lodash';

const Navbar = ({menu_data}) => {
  const [items, setItems] = useState(null);
  const [categories, setCategories] = useState(null);
  const [toggled, setToggled] = useState(false);
  const [submenuActive, setSubmenuActive] = useState(false);
  const [products, setProducts] = useState(null);
  const { t } = useTranslation();
  // let siteLogo = Logo;
  // if(currentLang() == 'nl'){
  //   //siteLogo = LogoNL;
  // }
  // if(currentLang() == 'de'){
  //   siteLogo = LogoDE;
  // }
  //let location = useLocation();
  //const history = useHistory();
	//history.pushState(null, null, location.href);
   /* window.onpopstate = function () {
        history.go(1);
    };
    */
  function HandleHamburgerMenu(event){
    event.preventDefault();
    setToggled(!toggled);
  }
  let toggledClass = (toggled) ? "collapsed menu__open" : "collapse menu__close";
  document.body.className = toggledClass;

  useEffect(() => {
      
      
    if(menu_data == undefined){
      getMenu('main-menu', 'menu_data');
      //getProducts();
      //getMenu('animals', 'animal_data');
    }

		if(menu_data !== undefined){
      setItems(menu_data);
		}

  }, [menu_data]);



  /*
  useEffect(() => {
    if(animal_data == undefined)
      getMenu('animals', 'animal_data');

		if(animal_data !== undefined){
      setCategories(animal_data);
		}

  }, [animal_data]);

  useEffect(() => {

      if(products_data == undefined)
          getProducts();

      if(products_data !== undefined && products == null){
          setProducts(products_data);
      }

  }, [products_data]);
*/
  /*
  const toggleSubmenu = (action, value) => {
    console.log(action, value);
    if(value == 'ons-vlees'){
      if(action == 'hover'){
        setSubmenuActive(true);
      }else{
        setSubmenuActive(false);
      }
    }
  }
  */
  var isExternalURL = (url) => { 
    if(url.includes('https') || url.includes('/'+currentLang()+'/') || url.includes('//')){
      return true;
    }else{
      return false;
    }
  }

  return (
    <div className={'header__menu'}>
      <div className="row align-items-center">
        <div className={"col-7 col-lg-2 offset-lg-0 order-lg-1 d-flex align-items-center"}>
          <div className={"menu__hamburger d-block d-lg-none"}>
            <button className={`menu__hamburger ${toggledClass}`} onClick={HandleHamburgerMenu} type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
              <span className={"icon-bar top-bar"}></span>
              <span className={"icon-bar middle-bar"}></span>
              <span className={"icon-bar bottom-bar"}></span>
            </button>
            <span className={"menu__hamburger__label"}><W>general.menu</W></span>
          </div>
          <div className={"header__logo"}>
              <Link className="logo" to={"/"+currentLang()}> {/* <Image src={siteLogo} alt="Grutto" /> */} </Link>
          </div>
        </div>
        <div className={"col-5 col-lg-2 order-lg-3" }>
          <div className="header__account">
            <a href={"/"+currentLang()+"/shop/my-account"}> <span className={"icon-user"}></span> <W>general.account</W> </a>
            <Basket />
          </div>
        </div>
        <div className="col-12 col-lg-8 order-lg-2 menu__navigation_items">
          <nav><ul>
            {items && Array.isArray(items) && items.map((item, index) =>{
              if(!item.parent_id){
                return (
                  <li key={'navlink-li-'+index} className={"top-menu" + index + (item.url == t("menu.products") ? " haschild" : "")}>
                    <Fragment>
                    {isExternalURL(item.url) && 
                      <a key={"navlink-"+index} href={item.url} className={"toplink"}><span className={item.icon_class}></span>{item.title}</a>
                    }
                    {!isExternalURL(item.url) && 
                    <NavLink key={"navlink-"+index} to={"/"+currentLang()+(item.url == t("menu.products") ? "" : "/"+item.url)} className={"toplink"} onClick={() => setToggled(false)} activeClassName="active" isActive={(match, location) => {
                      if (match) {
                        //console.log(location.pathname, match.url);
                        if (location.pathname !== "/"+currentLang()+"/" && match.url == "/"+currentLang() ) {
                          if (location.pathname.indexOf(t("menu.products")) > -1) {
                            return true; {/* highlight home if you are on subpage e.g. nl/ons-vlees/classic_v3_large */}
                          } else {
                              if(location.pathname === "/"+currentLang() || location.pathname.includes("/"+currentLang()+"/"+t('menu.animal'))){
                                return true;
                              }else{
                                return false;
                              }
                            //return false; {/* don't highlight home if you are on subpage e.g. nl/recepten/biefstuk */}
                          }
                        } else {
                          return true;
                        }
                      }
                    }}
                    >
                    <span className={item.icon_class}></span>
                    {item.title}
                    </NavLink>
                    }
                    
                    {isProduct(item.url) &&
                    <ul className={"submenu "+(submenuActive ? "active" : "")} onMouseOut={()=>setSubmenuActive(false)}>
                      <li className={"submenu__body "+currentLang()}>
                        {items && items.map((cat, index)=>{
                              //console.log(item);
                              if(cat.parent_id == item.menu_item_id){
                                return (
                                  <ul key={"animal-ul-"+index} className={"cat-"+index}>
                                    <li key={"animal-li-"+index} className="submenu__title"> <span className={cat.icon_class}></span> {cat.title} </li>
                                    {items && items.map((submenu, index)=>{
                                      if(submenu.parent_id == cat.menu_item_id){
                                        var menu_url = "";
                                        if(submenu.url){
                                          menu_url = submenu.url;
                                        }else if(submenu.product_slug){
                                          menu_url = productURL(null, submenu.product_slug, submenu.animal_type);
                                        }else{
                                          menu_url = null;
                                        }
                                        //console.log(submenu, item, cat);
                                        //console.log(menu_url, submenu);
                                        return (
                                          <Fragment>
                                              <li key={"animal-childs-"+index}>
                                                {isNil(menu_url) && 
                                                    <a>{submenu.title}</a>
                                                }
                                                {!isNil(menu_url) &&
                                                    <a href={menu_url}>{submenu.title}</a>
                                                }
                                              </li>
                                          </Fragment>
                                        )
                                      }
                                    })}
                                  </ul>
                                )
                              }
                        })}
                      </li>
                    </ul>
                    }
                    </Fragment>
                  </li>
                  )
                }
              })
            }</ul>
          </nav>
        </div>
      </div>
    </div>
  )
}

export default flatstore.connect(['menu_data'])(Navbar);
